import filterNavigation from './filterNavigation';
import mpkProject from './mpkProject';

export default {
  mpkProject,
  filterNavigation,
};
